import Layout from "../../components/Layout"
import AdminAdventure from "../../routes/Admin/admin.adventure";

const AdminComponent = () => {
    return (
        <Layout>
            <div className="flex items-center justify-center font-bold text-4xl min-h-[500px]">
                TO BE IMPLEMENTED
            </div>
        </Layout>
    )
}

export default AdminComponent;